import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {imageWidget_template} from "./imageWidget_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class DealsCaroussel_template extends vnTemplate {

    public imageWidget: imageWidget_template;
    protected carousselLogoTooltipContent: string;
    protected carousselLogoTooltip: infoButton_template;

    protected getTemplateHtml(): string {

        return `
        <div class="deals-caroussel-template">
            <div class="form-group">
                <label class="form-label">Logo</label>
                <div class="w-tooltips-adv pos-far-right short" style="margin-top: 1rem">
                    ${this.carousselLogoTooltip.getHtmlBuild()}
                </div>
                ${this.imageWidget.getHtmlBuild()}
            </div>
            <div class="form-group">
                <label class="form-label">Title</label>
                <input data-bind="value: title" class="input-text" type="text">
            </div>
            <div class="form-group">
                <label class="form-label">Excerpt</label>
                <textarea data-bind="value: excerpt" class="input-text"></textarea>
            </div>
            <div class="form-group">
                <label class="form-label">Badge</label>
                <input data-bind="value: badge" class="input-text" type="text">
            </div>
            <div class="form-group">
                <label class="form-label">Button Label</label>
                <input data-bind="value: buttonLabel" class="input-text" type="text">
            </div>
            <div class="form-group">
                <label class="form-label">Button Link</label>
                <input data-bind="value: buttonLink" class="input-text" type="url">
            </div>
            
            <div class="form-group">
                <strong class="form-sub-title icon i-dropdown-simple" data-bind="click: toggleBulletFieldsSection, css: { 'is-open' : bulletFieldsSectionOpen }">Bullets <small><em>(Optional)</em></small></strong>
            </div>
            <div data-bind="visible: bulletFieldsSectionOpen">
                <div class="form-group">
                    <label class="form-label">Bullet #1</label>
                    <input data-bind="value: bullet1" class="input-text" type="text">
                </div>
                <div class="form-group">
                    <label class="form-label">Sub-Bullet #1</label>
                    <input data-bind="value: subBullet1" class="input-text" type="text">
                </div>
                <div class="form-group">
                    <label class="form-label">Bullet #2</label>
                    <input data-bind="value: bullet2" class="input-text" type="text">
                </div>
                <div class="form-group">
                    <label class="form-label">Sub-Bullet #2</label>
                    <input data-bind="value: subBullet2" class="input-text" type="text">
                </div>
                <div class="form-group">
                    <label class="form-label">Bullet #3</label>
                    <input data-bind="value: bullet3" class="input-text" type="text">
                </div>
                <div class="form-group">
                    <label class="form-label">Sub-Bullet #3</label>
                    <input data-bind="value: subBullet3" class="input-text" type="text">
                </div>
            </div>
        </div>
`;
    }

    protected initPartial(): void {

        let imagePickerHelper = this.caller.getImagePickerHelper();

        this.imageWidget = new imageWidget_template("deals_caroussel_image", this.getTemplateViewModel(), this);
        this.imageWidget.setMode('single-select');
        this.imageWidget.setCaller(imagePickerHelper);

        this.carousselLogoTooltipContent = `
        <p>Select a logo that includes the brand name. It should have a transparent background and be visible over a white background.</p>
        `;

        this.carousselLogoTooltip = new infoButton_template('carosselLogoTooltip', this.getTemplateViewModel(), this.caller)
        this.carousselLogoTooltip.setTitle('Caroussel Logo');
        this.carousselLogoTooltip.setContent(this.carousselLogoTooltipContent);
    }

    protected getTemplateName(): string {

        return 'DealsCaroussel_template';
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    public buildViewModel() {

        let self = this;

        return {
            title: ko.observable(''),
            excerpt: ko.observable(''),
            bullet1: ko.observable(''),
            subBullet1: ko.observable(''),
            bullet2: ko.observable(''),
            subBullet2: ko.observable(''),
            bullet3: ko.observable(''),
            subBullet3: ko.observable(''),
            bulletFieldsSectionOpen: ko.observable(false),
            toggleBulletFieldsSection: function () {
                self.toggleBulletFieldsSection();
            },
            badge: ko.observable(''),
            buttonLabel: ko.observable(''),
            buttonLink: ko.observable('')
        };
    }

    public getTitle() {

        return this.getTemplateViewModel().title();
    }

    public setTitle(title): void {

        this.getTemplateViewModel().title(title);
    }

    public getExcerpt() {

        return this.getTemplateViewModel().excerpt();
    }

    public setExcerpt(excerpt): void {

        this.getTemplateViewModel().excerpt(excerpt);
    }

    public getBullet1() {

        return this.getTemplateViewModel().bullet1();
    }

    public setBullet1(bullet1): void {

        this.getTemplateViewModel().bullet1(bullet1);
        this.updateBulletFieldsSectionState();
    }

    public getSubBullet1() {

        return this.getTemplateViewModel().subBullet1();
    }

    public setSubBullet1(subBullet1): void {

        this.getTemplateViewModel().subBullet1(subBullet1);
        this.updateBulletFieldsSectionState();
    }

    public getBullet2() {

        return this.getTemplateViewModel().bullet2();
    }

    public setBullet2(bullet2): void {

        this.getTemplateViewModel().bullet2(bullet2);
        this.updateBulletFieldsSectionState();
    }

    public getSubBullet2() {

        return this.getTemplateViewModel().subBullet2();
    }

    public setSubBullet2(subBullet2): void {

        this.getTemplateViewModel().subBullet2(subBullet2);
        this.updateBulletFieldsSectionState();
    }

    public getBullet3() {

        return this.getTemplateViewModel().bullet3();
    }

    public setBullet3(bullet3): void {

        this.getTemplateViewModel().bullet3(bullet3);
        this.updateBulletFieldsSectionState();
    }

    public getSubBullet3() {

        return this.getTemplateViewModel().subBullet3();
    }

    public setSubBullet3(subBullet3): void {

        this.getTemplateViewModel().subBullet3(subBullet3);
        this.updateBulletFieldsSectionState();
    }

    public getBadge() {

        return this.getTemplateViewModel().badge();
    }

    public setBadge(badge): void {

        this.getTemplateViewModel().badge(badge);
    }

    public getButtonLabel() {

        return this.getTemplateViewModel().buttonLabel();
    }

    public setButtonLabel(buttonLabel): void {

        this.getTemplateViewModel().buttonLabel(buttonLabel);
    }

    public getButtonLink() {

        return this.getTemplateViewModel().buttonLink();
    }

    public setButtonLink(buttonLink): void {

        this.getTemplateViewModel().buttonLink(buttonLink);
    }

    public getImage() {

        return this.imageWidget.getImage();
    }

    public setImage(image): void {

        this.imageWidget.setImage(image);
    }

    public clearImage(): void {

        this.imageWidget.clearImage();
    }

    protected toggleBulletFieldsSection(): void {

        let vm = this.getTemplateViewModel();

        vm.bulletFieldsSectionOpen(!vm.bulletFieldsSectionOpen());
    }

    protected updateBulletFieldsSectionState(): void {

        this.getTemplateViewModel().bulletFieldsSectionOpen(this.hasBulletFieldsContent());
    }

    protected hasBulletFieldsContent(): boolean {

        let vm = this.getTemplateViewModel();
        let bulletFields = [
            vm.bullet1(),
            vm.subBullet1(),
            vm.bullet2(),
            vm.subBullet2(),
            vm.bullet3(),
            vm.subBullet3(),
        ];

        return bulletFields.some((field) => field && field.trim() !== '');
    }

    public buildCarousselData() {

        return {
            title: this.getTitle(),
            excerpt: this.getExcerpt(),
            bullet1: this.getBullet1(),
            subBullet1: this.getSubBullet1(),
            bullet2: this.getBullet2(),
            subBullet2: this.getSubBullet2(),
            bullet3: this.getBullet3(),
            subBullet3: this.getSubBullet3(),
            badge: this.getBadge(),
            buttonLabel: this.getButtonLabel(),
            buttonLink: this.getButtonLink(),
            logo: this.getImage()
        };
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/DealsCaroussel_template.ts